import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as common from '../../../../common'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.App.Input,
    graphql.schema.AppInput
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    icon: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    sessionVariables: graphql.transformers.IN.list(
      common.gql.dms.data.inputs.variable.INPUT,
      { onNullish: 'remove' },
    ),
    supportsScenarios: transformers.PASS_THROUGH,
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.App.Updates,
    graphql.schema.AppUpdates
  >({
    alias: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    icon: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    sessionVariables: graphql.transformers.IN.list(
      common.gql.dms.data.inputs.variable.INPUT,
      { onNullish: 'remove' },
    ),
  }),
)
